import { useMutation, useQueryClient } from 'react-query';
import {
  addUserIdentity,
  type addUserIdentityBody,
  type addUserIdentityResult
} from '../../services/userIdentities';

export function useAddUserIdentity() {
  const queryClient = useQueryClient();
  return useMutation<addUserIdentityResult, Error, addUserIdentityBody>(
    (body) => addUserIdentity(body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['userIdentities']);
        queryClient.invalidateQueries(['users']);
      }
    }
  );
}
